import { Controller } from '@hotwired/stimulus';
import { application } from 'src/app';
import './component.scss';

application.register('search-bar', class extends Controller {

  responsiveFade(event) {
    let whiteCardClasses = document.getElementById("white-card-search-bar")
    let autoCompleteInputs = document.getElementById("autocomplete-inputs")
    if (whiteCardClasses.classList.contains("responsive")) {
      whiteCardClasses.classList.remove("responsive")
      autoCompleteInputs.classList.remove("responsive")
    } else {
      whiteCardClasses.classList.add("responsive")
      autoCompleteInputs.classList.add("responsive")
    }
  }
})
